import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputOnlyNumbersErrorMessage = (
  <Trans>
    Ce champ ne doit contenir que des chiffres
  </Trans>
);
